import BarChartComponent from '@/components/ui/charts/BarChartComponent';
import { useMemo } from 'react';

export type WeeklyConsultationsByTypeProps = {
    data: Array<{ day: string, type: string, count: number }>;
    title: string;
}

function WeeklyConsultationsByTypeComponent(props: WeeklyConsultationsByTypeProps) {
    const { data, title } = props;

    const types = useMemo(() => [...new Set(data.map(item => item.type))], [data]);
    const transformedData = useMemo(() => types.map(type => ({
        label: type,
        values: data.filter(item => item.type === type).map(item => ({ subLabel: item.day, value: item.count }))
    })), [data, types]);

    return <BarChartComponent data={transformedData} title={`${title}`} />;
}

export default WeeklyConsultationsByTypeComponent; 
